module.exports = __webpack_public_path__ + "images/9a955fbb24f9ed405d5375d8b154ddb1.png";